module.exports = __webpack_public_path__ + "media/images/post/icon_author-65778c3e29a8040a0059d8c062b1a8e4.png";